module.exports = __webpack_public_path__ + "img/solution3.9bde7e94.png";